import { Component, ElementRef, ViewChild, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { EditableComponent } from '../editable.types';
import { AggregatedTasksService } from 'app/modules/aggregated-tasks/aggregated-tasks.service';
import { TaskStatus } from '../../../../shared/modules/legacy-tasks/tasks.types';
import { AccountService } from 'app/core';
import { ProjectAddContactComponent } from 'app/modules/projects/modals/project-add-contact/project-add-contact.component';
import { ProjectAddCompanyComponent } from 'app/modules/projects/modals/project-add-company/project-add-company.component';
import { FoldersTabService } from 'app/shared/modules/folders/folders.service';
import { RelatedToType } from 'app/shared/enums';
import { FileResource } from 'app/shared/modules/folders/folders.types';
import { filter, switchMap } from 'rxjs/operators';
import { FoldersTabViewFileComponent } from 'app/shared/modules/folders/view-file/view-file.component';
import { AddLinkToCustomObjectValueDialog } from 'app/shared/modules/custom-objects/modals/add-link-to-custom-object-value/add-link-to-custom-object-value.component';
import { ConfirmService } from '../../widgets/dialog/confirm/confirm.service';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { Project } from 'app/modules/projects/projects.types';
import { Store } from '@ngxs/store';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';
import { TsSnackbarService } from 'tsui';
import { UserState } from '@state/user/state';
import { CustomObject } from '@shared/modules/custom-objects/custom-objects.types';

const STANDARD_RELATED_TO_TYPES = [
  RelatedToType.Project,
  RelatedToType.Property,
  RelatedToType.Company,
  RelatedToType.Contact,
  RelatedToType.User,
  RelatedToType.FileResource,
  RelatedToType.Engagement,
];
@Component({
  templateUrl: './record-editable.component.html',
  styleUrls: ['./record-editable.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RecordEditableComponent extends EditableComponent implements OnInit {
  @ViewChild('inputEditorControl') inputEditorControl: ElementRef;

  public value: any = {};
  public values: any[] = [];
  public nestedObjectsValues = [];
  public editing: boolean = false;
  public customObjType: string = RelatedToType.Contact;
  private _originalValue;
  private _customObjId: number;
  public workflowStates: TaskStatus[];
  private project: Project;
  public redirecting = false;
  editingMultipleField = false;
  multipleUserIds;

  fileResource: FileResource;
  uploadingFile = false;

  options: any[];
  filteredOptions: any[];

  isCustomObjectLookup: boolean;

  private get currentCustomObject(): CustomObject {
    return this.store.selectSnapshot(ObjectsManagerState.get).find((x) => x.name === this.customObjType);
  }

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _aggregatedTasksService: AggregatedTasksService,
    private _accountService: AccountService,
    private readonly projectsService: ProjectsService,
    private _matDialog: MatDialog,
    private _changeDetectorRef: ChangeDetectorRef,
    private readonly foldersTabService: FoldersTabService,
    private readonly snackBar: TsSnackbarService,
    private readonly confirmService: ConfirmService,
    private readonly store: Store,
  ) {
    super();

    const currentAccount = this._accountService.getCurrentAccount();
    this._aggregatedTasksService.accountId = currentAccount.id;
    this.foldersTabService.accountId = currentAccount.id;
  }

  get isMultipleField(): boolean {
    return this.fieldDef?.meta?.multi_select;
  }

  ngOnInit(): void {
    super.ngOnInit();

    const fieldName = this.isNestedField ? this.fieldDef.name.split('.')[1] : this.fieldDef.name;

    this.isCustomObjectLookup = (fieldName.startsWith('cf_linked_') || this.isRelatedToCustomObject()) ?? false;

    this.setInitialValue();

    if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
      this.readonly = this.fieldDef.meta.readonly;
    }

    const customObjType = this.fieldDef?.meta?.record_type;

    this.customObjType = customObjType;
    if ([RelatedToType.Contact, RelatedToType.Company].includes(customObjType) || this.isCustomObjectLookup) {
      if (this.value) {
        let value;
        if (this.isMultipleField && this.value instanceof Array) {
          if (this.isNestedField) {
            this.values = this.value
              .map((item) => {
                const labelArray = JSON.parse(item.label);
                const parsedStrings = labelArray.map((str) => str.split('|')[1]);
                return parsedStrings;
              })
              .filter((item) => item.length > 0);

            value = this.values.join('| ');
          } else {
            this.values = this.value.map((val) => val?.split('|'));
            value = this.value.map((val) => val?.split('|')[1]).join(', ');
          }
        } else {
          if (this.isNestedField) {
            this.values = this.value.map((item) => item.label?.split('|')[1]).filter((item) => !!item);
          } else {
            let vals = this.value?.split('|');
            this._customObjId = vals[0] || '';
            value = vals[1] || '';
          }
        }

        if (!this.isMultipleField) this.value = value;
      }
      this._originalValue = this.value;
      return;
    } else if (this.customObjType == RelatedToType.User) {
      this.options = this.store.selectSnapshot(UserState.getActiveUsers);
      this.filteredOptions = this.options;

      if (this.value) {
        if (this.isMultipleField && this.value instanceof Array) {
          if (this.isNestedField) {
            // this.multipleUserIds = this.value.map((val) => JSON.parse(val.label)).map((us) => +us?.split('|')[0]);
            this.multipleUserIds = this.value.map((item) => {
              const labelArray = JSON.parse(item.label);
              const parsedStrings = labelArray.map((str) => +str.split('|')[0]);
              return parsedStrings;
            });

            this.value = this.value.map((item) => {
              const labelArray = JSON.parse(item.label);
              const parsedStrings = labelArray.map((str) => str.split('|')[1]);
              return parsedStrings;
            });
          } else {
            this.multipleUserIds = this.value.map((val) => +val?.split('|')[0]);
            this.value = this.value.map((val) => val?.split('|')[1]);
          }
        } else {
          let value;
          if (this.isNestedField) {
            value = this.value[0].label.split('|');
          } else {
            value = this.value.split('|');
          }

          this._customObjId = value[0];
          this.value = parseInt(value[0]);
        }
      }
    } else if (this.customObjType === RelatedToType.FileResource) {
      if (this.value) {
        if (this.isMultipleField) {
        } else {
          const value = this.value.split('|');
          this._customObjId = Number(value[0]);
          this.value = value[1];
        }
      }
      this._originalValue = this.value;

      this.getFileResource(this.model?.root_folder_resource_id, this._customObjId);
    } else if (this.customObjType === RelatedToType.Project) {
      this.getProjectData();
    } else if (this.customObjType === RelatedToType.Engagement) {
      //do nothing here since not serailizing to JSON we need to keep this
    } else {
      if (this.value) {
        this.value = JSON.parse(this.value);
      }
    }

    this._originalValue = this.value;

    this._aggregatedTasksService
      .getTaskStatuses()
      .pipe(untilComponentDestroyed(this))
      .subscribe((taskStatuses) => {
        this.workflowStates = taskStatuses;
      });
  }

  openContactModal(contactId?: number): void {
    if (this.isDisabled) {
      return;
    }

    const data = {
      data: { model: this.model, byPass: true },
    };

    const customObjectData = {
      width: '40vw',
      height: 'auto',
      data: {
        customObjectType: this.customObjType,
        customObjectId: this.data?.customObjectId ?? this.currentCustomObject.id,
        related_to_type: this.fieldDef.related_to_type,
        object: this.model,
        canAddNewRecord:
          this.isCustomObjectLookup &&
          !STANDARD_RELATED_TO_TYPES.includes(this.fieldDef.meta?.record_type as RelatedToType),
      },
    };

    let dialogRef: MatDialogRef<any>;
    if (this.customObjType == RelatedToType.Contact) {
      dialogRef = this._matDialog.open(ProjectAddContactComponent, data);
    } else if (this.customObjType == RelatedToType.Company) {
      dialogRef = this._matDialog.open(ProjectAddCompanyComponent, data);
    } else if (this.isCustomObjectLookup) {
      dialogRef = this._matDialog.open(AddLinkToCustomObjectValueDialog, customObjectData);
    }

    dialogRef
      .afterClosed()
      .pipe(
        untilComponentDestroyed(this),
        filter((result) => !!result),
      )
      .subscribe((result) => {
        const fieldValue = this.setFieldValueAfterDialogClose(result);
        this.updateModel();

        if (this.meta?.origin === 'app-table' && result?.model) {
          this.update.emit({ [this.fieldDef.name]: fieldValue });
        } else {
          this.update.emit({ [this.fieldDef.name]: fieldValue });
        }
      });
  }

  private setFieldValueAfterDialogClose(result: any): string | number | string[] {
    let fieldValue: unknown;

    // If this is a custom object lookup, we need to get the field value from the custom object's search field
    if (
      this.isCustomObjectLookup &&
      !STANDARD_RELATED_TO_TYPES.includes(this.fieldDef.meta?.record_type as RelatedToType)
    ) {
      // Get the name of the search field that was used to find this custom object value
      const searchFieldName = this.currentCustomObject.fields.find(
        (x) => x.id === this.currentCustomObject.search_custom_field_id,
      )?.name;

      // Get the value of the search field from the result's model data, if the search
      // field is not found, send an empty string since we don't know what field to display.
      fieldValue = result.model[searchFieldName] ?? '';
    } else {
      // For standard lookups (non-custom objects), use the model's name as the field value
      fieldValue = result.model.name;
    }

    const formattedValue = fieldValue === '' ? result.model.id : `${result.model.id}|${fieldValue}`;

    if (this.isMultipleField) {
      this.value.push(formattedValue);
      return this.value?.map((val) => +val?.split('|')[0]) || [];
    } else {
      return formattedValue;
    }
  }

  removeModelField(event: Event): void {
    event.stopPropagation();

    if (this.customObjType === RelatedToType.FileResource && !this.fileResource) {
      this.fileNotFoundSnackBar();
      return;
    }

    this.confirmService
      .openConfirmationModal()
      .pipe(filter((result: boolean) => result))
      .subscribe(() => {
        this.value = null;
        this.updateModel();
        this.update.emit({ [this.fieldDef.name]: this.value });
        this._changeDetectorRef.markForCheck();
      });
  }

  goToRecord() {
    let route = this._activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }

    this._router.navigate(['../', this.value.project_id, 'tasks', this.value.task_list_id, this.value.id], {
      relativeTo: this._activatedRoute,
    });
  }

  removeItem(item) {
    this.value = this.value.filter((val) => val?.toLowerCase() !== item.toLowerCase());
    const ids = this.value?.map((val) => +val.split('|')[0]);
    this.update.emit({ [this.fieldDef.name]: ids });
    this.updateModel();
    this._changeDetectorRef.markForCheck();
  }

  goToBaseRecord(item?: any) {
    if (this.isDisabled || this.redirecting) {
      return;
    }

    let route = this._activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    let vals = this.getValues();

    if (item) {
      vals = item.split('|');
    }

    if (this.customObjType == RelatedToType.Contact) {
      this._router.navigate(['/contacts', vals[0]]);
    } else if (this.customObjType == RelatedToType.Company) {
      this._router.navigate(['/companies', vals[0]]);
    } else if (this.customObjType == RelatedToType.Task) {
      this._router.navigate([
        '/projects',
        this.model.pipeline_id,
        this.value.project_id,
        'tasks',
        this.value.task_list_id,
        this.value.id,
      ]);
    } else if (this.isCustomObjectLookup) {
      if (this.customObjType == RelatedToType.Property) {
        this._router.navigate(['/properties', vals[0]]);
      } else if (this.customObjType == RelatedToType.Project) {
        const pipeline_id = this.model?.pipeline_id || this.project?.pipeline_id;
        if (pipeline_id) {
          this._router.navigate(['/projects', pipeline_id, vals[0]]);
        } else {
          this.redirecting = true;
          this.projectsService.getProjectById(vals[0]).subscribe((response) => {
            this._router.navigate(['/projects', response.pipeline_id, vals[0]]);
            this.redirecting = false;
          });
        }
      } else {
        const coId = this.currentCustomObject.id || this.data?.customObjectId;
        this._router.navigate(['/objects', coId, vals[0], 'details']);
      }
    }
  }

  getValues() {
    if (this.model[this.fieldDef.name] && typeof this.model[this.fieldDef.name] === 'string')
      return this.model[this.fieldDef.name].split('|');
    else return null;
  }

  private getProjectData(): void {
    const vals = this.getValues();

    if (vals.filter((x) => !x).length > 0) {
      return;
    }

    this.projectsService
      .getProjectById(vals[0])
      .pipe(untilComponentDestroyed(this))
      .subscribe((project: Project) => {
        this.project = project;
      });
  }

  edit() {
    if (!this.editing && !this.readonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputEditorControl?.nativeElement.focus();
      }, 100);
    }
  }

  openedChangedMultipleUser($event) {
    if (!$event) {
      this.editingMultipleField = false;
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  onBlur($event: Event) {
    this.editing = false;
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  onSelectionChange($event: MatSelectChange) {
    this.value = $event.value;
    this.updateModel();
  }

  updateTask(task) {
    this._aggregatedTasksService.simpleUpdateTask(task).subscribe();
  }

  updateModel() {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  private getFileResource(folderId: number, fileId: number) {
    this.setFolderSettings();
    if (folderId && fileId)
      this.foldersTabService
        .getFile(folderId, fileId)
        .pipe(untilComponentDestroyed(this))
        .subscribe((fileResource) => {
          this.fileResource = fileResource;
        });
  }

  hasNoRecordType(): boolean {
    return !this.fieldDef?.meta?.record_type;
  }

  private setFolderSettings() {
    if (this.data?.relatedToType === RelatedToType.Project) {
      this.foldersTabService.moduleId = this.model?.id;
      this.foldersTabService.moduleBaseUrl = 'projects';
    } else if (this.data?.relatedToType === RelatedToType.Property) {
      this.foldersTabService.moduleId = this.model?.id;
      this.foldersTabService.moduleBaseUrl = 'properties';
    } else if (this.data?.relatedToType === RelatedToType.Task) {
      this.foldersTabService.moduleId = this.model?.id;
      this.foldersTabService.moduleBaseUrl = 'tasks';
    }
  }

  onFileChanged(event: InputEvent) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;

    const folderId = this.model?.root_folder_resource_id;
    const fileResource = {
      folder_resource_id: folderId,
      name: file?.name,
    };

    if (folderId) {
      this.uploadingFile = true;
      this.setFolderSettings();
      this.foldersTabService
        .createFile(folderId, fileResource)
        .pipe(
          untilComponentDestroyed(this),
          switchMap((fileResource) => this.foldersTabService.uploadDocument(folderId, fileResource.id, file)),
        )
        .subscribe((fileResource) => {
          this.fileResource = fileResource;
          if (this.isMultipleField) {
            this.value.push(`${fileResource.id}|${fileResource.name}`);
          } else {
            this.value = fileResource.id;
          }

          this.updateModel();
          this.update.emit({ [this.fieldDef.name]: this.value });
          this.uploadingFile = false;
        });
    }
  }

  viewFile(fileResource: FileResource | FileResource[]): void {
    if ((!this.value && this.readonly) || this.isMultipleField) {
      return;
    }

    if (!fileResource) {
      this.fileNotFoundSnackBar();
      return;
    }

    fileResource = Array.isArray(fileResource) ? fileResource[0] : fileResource;

    this.setFolderSettings();
    this._matDialog.open(FoldersTabViewFileComponent, {
      panelClass: 'mailbox-compose-dialog',
      minWidth: '100vw',
      height: '100vh',
      data: { fileResource },
    });
  }

  private isRelatedToCustomObject(): boolean {
    return !STANDARD_RELATED_TO_TYPES.includes(this.fieldDef?.meta?.record_type);
  }

  private fileNotFoundSnackBar(): void {
    this.snackBar.open('File not found', 'error', 'Close');
  }

  private setInitialValue(): void {
    if (this.isNestedField) {
      this.value = this.getValue();
      this.nestedObjectsValues = this.value;
      return;
    }

    if (this.isCustomObjectLookup && this.isMultipleField) {
      this.value =
        this.model[this.fieldDef.name] instanceof Array
          ? this.model[this.fieldDef.name]
          : JSON.parse(this.model[this.fieldDef.name] ?? '[]');
    } else {
      this.value = this.model[this.fieldDef.name];
    }
  }
}
